import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { ScanQrcodeStoreContext } from './contexts/StoreContext'
import { ScanQrcodeStoreProviderProps } from './interface'
import { createScanQrcodeStore } from './store/createStore'
import { ScanQrcodeStoreUpdator } from './StoreUpdator'

export const ScanQrcodeStoreProvider = ({
  children,
  /* -------------------------------------------------------------------------- */
  /*                        ScanQrcodeStoreUpdator Props                        */
  /* -------------------------------------------------------------------------- */
  autoLogin,
  onScan,
  onReload
}: PropsWithChildren<ScanQrcodeStoreProviderProps>) => {
  const store = useCreation(createScanQrcodeStore, [])

  return (
    <ScanQrcodeStoreContext value={store}>
      <ScanQrcodeStoreUpdator
        autoLogin={autoLogin}
        onReload={onReload}
        onScan={onScan}
      />
      {children}
    </ScanQrcodeStoreContext>
  )
}
